import Vue from "vue"
import WCL from "@blinkist/web-component-library"

Vue.use(WCL)
